// extracted by mini-css-extract-plugin
export var fadeInAnimation = "TopScroller-module--fadeInAnimation--70ff5";
export var icon = "TopScroller-module--icon--b2c20";